<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dark
    >
      <v-card-title>REALTOR CA SCRAPPER</v-card-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <RealtorCa/>
    </v-main>
  </v-app>
</template>

<script>
import RealtorCa from "@/components/RealtorCa";

export default {
  name: 'App',

  components: {
    RealtorCa,
  },

  data: () => ({
    //
  }),
};
</script>
